export function taskTimelineMessages(messages, activeJob) {
  const owned = new Map();
  for (const message of messages) {
    if (message.role === "assistant" && message.execution?.job_id) owned.set(message.execution.job_id, message.execution);
  }
  if (activeJob?.job_id) owned.set(activeJob.job_id, activeJob);
  return messages.filter(message => {
    if (message.role !== "user" || !message.execution?.followup) return true;
    const task = owned.get(message.execution.task_job_id);
    const steps = task?.activity?.steps || task?.usage?.activity?.steps || [];
    // Never hide a message unless the corresponding task timeline actually contains it.
    return !steps.some(step => step.kind === "user" && step.message_id === message.message_id);
  });
}
